import i18n from '@/i18n'
export default [
  // 商品详情页
  {
    path: 'goodDetail',
    component: () => import('@/views/modules/good/goodDetail'),
    name: 'goodDetail',
    meta: {
      title: i18n.t('route.goodDetail'),
      isTab: true
    }
  },
  // 商品列表
  {
    path: 'goodCategoryList',
    component: () => import('@/views/modules/good/goodCategoryList'),
    name: 'goodCategoryList',
    meta: { title: i18n.t('route.goodCategoryList'), needToken: false }
  },
  // 品牌列表
  {
    path: 'brandList',
    component: () => import('@/views/modules/good/brandList'),
    name: 'brandList',
    meta: { title: i18n.t('route.brandList'), needToken: false }
  },
  // 品牌商品列表
  {
    path: 'goodBrandCategoryList',
    component: () => import('@/views/modules/good/goodBrandCategoryList'),
    name: 'goodBrandCategoryList',
    meta: { title: i18n.t('route.brandProductList'), needToken: false }
  },
  // 搜索商品列表
  {
    path: 'goodSearchCategoryList',
    component: () => import('@/views/modules/good/goodSearchCategoryList'),
    name: 'goodSearchCategoryList',
    meta: { title: i18n.t('route.searchPage'), needToken: false }
  },
  // 搜索商品列表跳转
  {
    path: 'goodnull',
    component: () => import('@/views/modules/good/goodnull'),
    name: 'goodnull',
    meta: { title: i18n.t('route.searchPage'), needToken: false }
  }
]
